import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const UserImport = lazy(() =>
  import("@scenes/UserImport").then((module) => ({
    default: module.UserImport,
  }))
);

export const importUsersNRO: NavigationRoutingObject = {
  Component: UserImport,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) => t("import-users-menu-option", "Import Users"),
  description: (t: I18nT<"dashboard-navigation">) =>
    t("import-users-description-nav", "Import a CSV of user information to add or update user profiles"),
  icon: "nav-system-import-users",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("user-import", "User Import")],
      description: t("previously-user-import", 'Previously "User Import"'),
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/users/user_import/:appGroupId",
};
